import script from "./FormGradeAndStatus.vue?vue&type=script&setup=true&lang=js"
export * from "./FormGradeAndStatus.vue?vue&type=script&setup=true&lang=js"

import "./FormGradeAndStatus.vue?vue&type=style&index=0&id=e8944d3e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e8944d3e"]])

export default __exports__